import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { UserRole } from "../types/church";

const DeveloperRoute = ({ children }) => {
  const { currentUser, churchUser, loading } = useAuth();

  // Aguardar carregamento da autenticação
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  // Verificar se usuário está autenticado
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se usuário tem role de desenvolvedor
  if (!churchUser || churchUser.role !== UserRole.DESENVOLVEDOR) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card border-warning">
              <div className="card-header bg-warning text-dark">
                <h5 className="mb-0">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Acesso Restrito
                </h5>
              </div>
              <div className="card-body">
                <p className="mb-3">
                  Este painel é apenas para desenvolvedores.
                </p>
                <div className="alert alert-info">
                  <strong>Usuário atual:</strong> {currentUser?.email}
                  <br />
                  <strong>Role atual:</strong>{" "}
                  {churchUser?.role || "Não definida"}
                  <br />
                  <strong>Role necessária:</strong> {UserRole.DESENVOLVEDOR}
                </div>
                <button
                  className="btn btn-primary"
                  onClick={() => window.history.back()}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default DeveloperRoute;
